import { Api, Auth } from '~/services';

export const getUpcomingEvents = async () => {
    return Api.get( '/events/upcoming', {}, ( data, error ) => {
        if ( !data || !data.events || error ) return [];

        return data.events;
    })
}



// WEBPACK FOOTER //
// ./src/js/api/events.js